import { useMutation } from '@tanstack/react-query';

import { QuestionnairesApi } from 'api';
import { BANK_QUESTIONNAIRE_KEY } from '../../keys';
import { useUser } from '../../user';
import { useBankQuestionnaireCache } from '../useBankQuestionnaireCache';

export function usePublishQuestionnaire() {
  const { userBankId } = useUser();
  const { applyPublishedQuestionnaire } = useBankQuestionnaireCache();
  const questionnairesApi = new QuestionnairesApi();

  const { mutateAsync: publishQuestionnaire, isPending: isPublishQuestionnairePending } = useMutation({
    mutationKey: [BANK_QUESTIONNAIRE_KEY],
    mutationFn: (questionnaireId: string) =>
      questionnairesApi.publishQuestionnaire(userBankId, questionnaireId),
    onSuccess: applyPublishedQuestionnaire,
    meta: {
      snackbarErrorMessage: 'There was an error publishing the questionnaire.'
    }
  });

  return { publishQuestionnaire, isPublishQuestionnairePending };
}
